import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, ignoreElements, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { SIBASI_SYSTEM_APP_MODULES } from 'src/app/common/model/sibasi-system.model';
import * as XLSX from 'xlsx';
import { IFile, IFolder } from '../../model/file.model';
import { ISibasiHTTPResponse } from '../../model/sibasiHTTPResponse.model';
import { IModule, IPagination } from '../../model/util.model';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  convertedJson!: string;
  worksheet: any;
  constructor(private httpClient: HttpClient) {}

  // uploadFile(file: FormData): Observable<HttpEvent<any>> {

  //   const req = new HttpRequest('POST', `${environment.api_url}files/upload`, file, {
  //     reportProgress: true,
  //     responseType: 'json'
  //   });

  //   return this.httpClient.request(req);
  // }

  uploadFile_Old(file: FormData, uploadURL: string): Observable<HttpEvent<any>> {
    const req = new HttpRequest('POST', `${environment.api_url}${uploadURL}`, file, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.httpClient.request(req);
  }

  selectUploadFileURL(module: IModule): string {
    let fileUploadURL = '';
    switch (module.moduleType) {
      case SIBASI_SYSTEM_APP_MODULES.MEETING:
        fileUploadURL = `meeting/document/${module.moduleItemId}`;
        break;
      case SIBASI_SYSTEM_APP_MODULES.USER:
        fileUploadURL = `personal/upload`;
        break;

      default:
        fileUploadURL = `personal/uploadForModule/${module.moduleType}/${module.moduleItemId}`;
        break;
    }
    return fileUploadURL;
  }

  uploadFile(file: FormData, module: IModule): Observable<HttpEvent<any>> {
    const fileUploadURL = this.selectUploadFileURL(module);
    const req = new HttpRequest('POST', `${environment.api_url}${fileUploadURL}`, file, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.httpClient.request(req);
  }

  uploadNewFileVersionOrMakeCopy(
    file: FormData,
    module: IModule,
    documentId?: string
  ): Observable<HttpEvent<any>> {
    const fileUploadURL = `personal/uploadForModule/${module.moduleType}/${
      module.moduleItemId
    }${documentId ? '/' + documentId : ''}`;
    const req = new HttpRequest('POST', `${environment.api_url}${fileUploadURL}`, file, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.httpClient.request(req);
  }

  uploadOnDropbox(file: FormData): Observable<HttpEvent<any>> {
    const req = new HttpRequest('POST', `${environment.api_url}upload/dropbox`, file, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.httpClient.request(req);
  }

  uploadOnGoogleDrive(file: FormData): Observable<HttpEvent<any>> {
    const req = new HttpRequest(
      'POST',
      `${environment.api_url}upload/google/drive`,
      file,
      {
        reportProgress: true,
        responseType: 'json'
      }
    );

    return this.httpClient.request(req);
  }

  logoUpload(file: FormData): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}organizationadmin/new/logo`,
      file
    );
  }

  signUpload(file: FormData): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}organizationadmin/new/sign`,
      file
    );
  }

  stampUpload(file: FormData): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}organizationadmin/new/stamp`,
      file
    );
  }

  getOrganizationLogo(): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}organizationadmin/logos/current`
    );
  }

  getOrganizationSignAndStamp(): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}organizationadmin/sign-stamp`
    );
  }

  getAllOrganizationLogo(): Observable<ISibasiHTTPResponse<IFile[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile[]>>(
      `${environment.api_url}organizationadmin/logos/current`
    );
  }

  getFilesByModuleId(
    moduleItemId: string | undefined,
    moduleType?: string
  ): Observable<ISibasiHTTPResponse<IFile[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile[]>>(
      `${environment.api_url}files/getModuleFilesByModuleItemId/${moduleItemId}/${moduleType}`
    );
  }
  getFilesByModuleTypeAndModuleItemId(
    module: IModule
  ): Observable<ISibasiHTTPResponse<IFile[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile[]>>(
      `${environment.api_url}files/getModuleFilesByModuleItemId/${module.moduleItemId}/${module.moduleType}`
    );
  }
  getUserFilesPagination(
    pagination: IPagination<IFile[]>
  ): Observable<ISibasiHTTPResponse<IPagination<IFile[]>>> {
    return this.httpClient.post<ISibasiHTTPResponse<IPagination<IFile[]>>>(
      `${environment.api_url}personal/filesPaginated`,
      pagination
    );
  }
  getProfilePictureMetaData(): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}user/profilePicture`
    );
  }
  profileImageUpload(file: FormData): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}user/profilePicture`,
      file
    );
  }
  getImageFileById(fileId: string, isPublicRequest: 'Y' | 'N' = 'N'): Observable<Blob> {
    return this.httpClient
      .get(
        `${environment.api_url}files/downloadImageBySibasiFileId/${fileId}?isPublicRequest=${isPublicRequest}`,
        {
          responseType: 'blob'
        }
      )
      .pipe(catchError(() => of().pipe(ignoreElements())));
  }
  getPDFFileById(fileId: string): Observable<Blob> {
    return this.httpClient
      .get(`${environment.api_url}files/downloadFile/${fileId}`, {
        responseType: 'blob'
      })
      .pipe(
        map((res: any) => {
          const fileURL = URL.createObjectURL(res);
          window.open(fileURL);
          return res;
        })
      );
  }

  deleteFile(fileRefId: string): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}files/delete/${fileRefId}`
    );
  }
  deleteFileByRefId(fileRefId: string): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}files/sample/delete/${fileRefId}`
    );
  }
  downloadFile(id: string): Observable<Blob> {
    return this.httpClient.get(`${environment.api_url}files/downloadfile/${id}`, {
      responseType: 'blob'
    });
  }
  downloadImageFile(id: string, isPublicRequest: 'Y' | 'N' = 'N'): Observable<Blob> {
    return this.httpClient.get(
      `${environment.api_url}files/downloadImagesOnly/${id}?isPublicRequest=${isPublicRequest}`,
      {
        responseType: 'blob'
      }
    );
  }

  readExcel(fileUploaded: File): any {
    const readFile = new FileReader();
    readFile.onload = (e) => {
      const storeData: any = readFile.result;
      const data = new Uint8Array(storeData);
      const arr = [];
      for (let i = 0; i !== data.length; ++i) {
        arr[i] = String.fromCharCode(data[i]);
      }
      const bstr = arr.join('');
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const firstSheetName = workbook.SheetNames[0];
      this.worksheet = workbook.Sheets[firstSheetName];
    };
    readFile.readAsArrayBuffer(fileUploaded);
  }

  readAsJson(): any {
    let jsonData;
    jsonData = XLSX.utils.sheet_to_json(this.worksheet, { raw: false });
    // jsonData = JSON.stringify(jsonData);
    return jsonData;
  }

  uploadExcelToProject(
    projectId: string,
    files: File[]
  ): Observable<ISibasiHTTPResponse<File[]>> {
    return this.httpClient.post<ISibasiHTTPResponse<File[]>>(
      `${environment.api_url}monival/client/issues/upload/excel/${projectId}`,
      files
    );
  }

  getOrganizationFiles(): Observable<ISibasiHTTPResponse<IFile[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile[]>>(
      `${environment.api_url}files/allOrganizationFiles`
    );
  }

  addViewers(fileId: string, viewers: any[]): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}files/addviewers/${fileId}`,
      viewers
    );
  }

  updateFileInformation(
    fileId: string,
    update: any
  ): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}files/update/${fileId}`,
      update
    );
  }

  editFavorite(fileId: string, update: any): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}files/favorite/${fileId}`,
      update
    );
  }

  getFavoriteFiles(): Observable<ISibasiHTTPResponse<IFile[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile[]>>(
      `${environment.api_url}files/allFavoriteFiles`
    );
  }

  generalFileUpload(
    file: FormData,
    fileId?: string
  ): Observable<ISibasiHTTPResponse<any>> {
    return this.httpClient.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}files/general/upload/${fileId}`,
      file
    );
  }

  showPDFFile(fileId: string): Observable<string> {
    return this.httpClient
      .get(`${environment.api_url}files/downloadFile/${fileId}`, {
        responseType: 'blob'
      })
      .pipe(
        map((res: any) => {
          const fileURL = URL.createObjectURL(res);
          return fileURL;
        })
      );
  }

  getFile(fileId: string): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}files/getFileById/${fileId}`
    );
  }

  getRecentFiles(): Observable<ISibasiHTTPResponse<IFile[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile[]>>(
      `${environment.api_url}files/allRecentFiles`
    );
  }

  // ********************** FOLDER **********************
  getFoldersPagination(
    pagination: IPagination<IFolder[]>
  ): Observable<ISibasiHTTPResponse<IPagination<IFolder[]>>> {
    return this.httpClient.post<ISibasiHTTPResponse<IPagination<IFolder[]>>>(
      `${environment.api_url}folder/all`,
      pagination
    );
  }

  getAllFolders(): Observable<ISibasiHTTPResponse<IFolder[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFolder[]>>(
      `${environment.api_url}folder/all`
    );
  }

  createFolder(folder: IFolder): Observable<ISibasiHTTPResponse<IFolder>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFolder>>(
      `${environment.api_url}folder/new`,
      folder
    );
  }

  updateFolder(folder: IFolder): Observable<ISibasiHTTPResponse<IFolder>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFolder>>(
      `${environment.api_url}folder/update/${folder._id}`,
      folder
    );
  }

  deleteFolder(folderId: string): Observable<ISibasiHTTPResponse<IFolder>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IFolder>>(
      `${environment.api_url}folder/delete/${folderId}`
    );
  }

  archiveFolder(folderId: string): Observable<ISibasiHTTPResponse<IFolder>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IFolder>>(
      `${environment.api_url}folder/archive/${folderId}`
    );
  }

  // ********************** SIGNATURE **********************
  requestSignature(
    userIds: string[],
    fileId: string
  ): Observable<ISibasiHTTPResponse<any>> {
    return this.httpClient.post<ISibasiHTTPResponse<any>>(
      `${environment.api_url}esign/upload/${fileId}`,
      userIds
    );
  }

  // ********************** TO BE DISCUSSED **********************

  itemImageUpload(
    file: FormData,
    itemId: string | undefined
  ): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.post<ISibasiHTTPResponse<IFile>>(
      `${environment.api_url}pos/item/${itemId}/uploadFile`,
      file
    );
  }
}
